import { SignalTypeMeta } from "@megaron/resource";

export const catalogSignalTypes = {} as const satisfies Record<string, SignalTypeMeta>;
